import actions from "./actions";
import mutations from "./mutations";
import * as getters from "./getters";

export const defaultCartState = () => {
  return {
    items: []
  };
};
export const defaultOrderState = () => {
  return {
    id: null
  };
};

export const defaultInventoryState = () => {
  return {};
};

export const defaultFormState = () => {
  return {
    shippingForm: {
      formAttributes: {
        shipping_name: null,
        shipping_address_1: null,
        shipping_address_2: null,
        shipping_city: null,
        shipping_province: null,
        shipping_postcode: null,
        shipping_country: null
      },
      formIsValid: false
    }
  };
};

export const getStorefrontDefaultState = () => {
  return {
    storefront: {
      currency: null,
      currency_decimals: null,
      currency_symbol: null,
      has_products: false,
      has_products_for_sale: false,
      id: null,
      is_accepting_orders: false,
      is_active: false,
      show_service_fees: false,
      service_fee_label: 'application and fulfillment fees'
    },
    meta: {
      parent_passcode: null
    },
    products: [],
    inventory: defaultInventoryState(),
    cart: defaultCartState(),
    order: defaultOrderState(),
    forms: defaultFormState()
  };
};

// initial state
const state = getStorefrontDefaultState();

export default {
  state,
  mutations,
  actions,
  getters
};
